import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const DesignationContractor = () => {
  return (
    <SettingsMetaData propertyName={"Designation_Contractor"} viewPropertyName={"Designation"} />
  );
};
export default DesignationContractor;